import PartService from "../../services/PartService";
import FormService from "../../services/FormService";

export default {
  namespaced: true, // all the state, mutations, actions, getters in this module is unique to this store module
  state() {
    return {
      parts: [],
      onlyForCust: false,
      carouselProducts: [],
      isLoading: true,
    };
  },
  mutations: {
    restQuantityByIndex(state, productIndex) {
      state.parts[productIndex].quant = 0;
    },
    updatePart(state, obj) {
      var { productIndex, part } = obj;
      state.parts[productIndex] = { ...part };
    },
    setParts(state, partsList) {
      state.parts = partsList;
    },
    toggleCustOnly(state, mode) {
      state.onlyForCust = mode;
    },
    setFavorite(state, Part) {
      let index = state.parts.findIndex((part) => part.part === Part);
      console.log(index);
    },
    setIsLoading(state, isLoading) {
      state.isLoading = isLoading;
    },
    appendParts(state, partsList) {
      state.parts = [...state.parts, ...partsList];
    },
    updatePartSendedRequestPriceList(state, part) {
      const partIndex = state.parts.findIndex((p) => p.part === part.part);
      if (partIndex !== -1) {
        state.parts[partIndex] = {
          ...state.parts[partIndex],
          sentPriceListRequest: true,
        };
      }
    },
    setCarouselProducts(state, products) {
      state.carouselProducts = products;
    },
  },
  actions: {
    //i call this in the App.vue beacuse search bar show in header and body of the app
    async findParts(context, query) {
      let user = context.rootGetters["AuthModule/getUser"];
      // Single-product-by-id lookups (product modal detail, meta tags) share
      // this action with the listing fetch but shouldn't toggle the shared
      // isLoading flag the listing's skeletons read — only a real listing
      // fetch (no id, first page) should show the skeleton.
      const isListingFetch = !query.id && (!query.page || query.page === 1);
      try {
        if (isListingFetch) {
          //Only set isLoading to true when it's the first page, for pagination no skelletons will be shown
          context.commit("setIsLoading", true);
        }
        var partsRes = await PartService.findParts({ query, user });
        if (!query.page) {
          // await context.commit("setParts", partsRes.data.parts);
        } else {
          // await context.commit("appendParts", partsRes.data.parts);
        }
        return partsRes.data;
      } catch (err) {
        console.log(err);
      } finally {
        if (isListingFetch) {
          context.commit("setIsLoading", false);
        }
      }
    },
    async sendRquestAddToPriceList(context, RequestObj) {
      try {
        console.log(context);

        const { part } = RequestObj;
        let res = await FormService.sendRequestAddToPriceList(RequestObj);
        context.commit("updatePartSendedRequestPriceList", part);
        return res;
      } catch (err) {
        console.log(err);
      }
    },
    restAllQuantity(context, lines) {
      lines.forEach((line) => {
        let { part } = line.Part;
        var productIndex = context.getters.getPartIndexById(part);
        console.log(productIndex);

        if (productIndex !== -1) {
          context.commit("restQuantityByIndex", productIndex);
        }
      });
    },
    restQuantityByPart(context, line) {
      let { part } = line.Part;
      var productIndex = context.getters.getPartIndexById(part);
      if (productIndex !== -1) {
        context.commit("restQuantityByIndex", productIndex);
      }
    },
    updateProduct(context, obj) {
      var { product, quantity } = obj;
      product.quant = quantity;
      context.dispatch("updatePart", product);
      if (quantity) {
        context.dispatch("Orders/addProductToCart", product, { root: true });
      } else {
        context.dispatch("Orders/removeProductFromCart", product, {
          root: true,
        });
      }
    },
    updatePart(context, part) {
      var productIndex = context.getters.getPartIndexById(part.part);
      context.commit("updatePart", { productIndex, part });
    },
    toggleThis(context, mode) {
      context.commit("toggleCustOnly", mode);
    },

    async toggleFavorite(context, part) {
      context.dispatch("startLoading", null, { root: true });
      try {
        await PartService.starProduct(part);
      } catch (err) {
        console.log("error starting product:" + err);
        context.dispatch(
          "stopLoading",
          {
            status: "error",
            message: "ארעה שגיאה, מומלץ לרענן את הדף ולנסות שוב",
          },
          { root: true },
        );
      }
      context.commit("setFavorite", part);
      context.dispatch(
        "stopLoading",
        { status: "success", message: "עודכן במועדפים" },
        { root: true },
      );
    },
    fetchRelatedProducts: async (context, catIdObj) =>
      await PartService.fetchRelatedProducts(catIdObj),
    async fetchCarouselProducts(context) {
      try {
        const user = context.rootGetters["AuthModule/getUser"];
        const response = await PartService.getCarouselProducts(user);
        if (response.data.success) {
          context.commit("setCarouselProducts", response.data.parts);
        }
        return response.data;
      } catch (error) {
        console.error("Error fetching carousel products:", error);
        throw error;
      }
    },
  },
  getters: {
    getPartIndexById: (state) => (part) => {
      return state.parts.findIndex((Part) => Part.part === part);
    },
    getPartLengths: (state) => (partId) => {
      //console.log('part iddddd: ', partId);
      console.log(partId);
      return state.onlyForCust;
    },
    getParts(state) {
      return state.parts;
    },
    getonlyForCust(state) {
      return state.onlyForCust;
    },
    getCategories(state) {
      let Categories = {};

      state.parts.forEach((part) => {
        if (part.Family) {
          if (typeof Categories[part.familyname] === "undefined") {
            Categories[part.familyname] = part.Family;
            Categories[part.familyname].counter = 0;
            Categories[part.familyname].custCounter = 0;
          }
          Categories[part.familyname].counter++;
          if (part.CustParts.length > 0)
            Categories[part.familyname].custCounter++;
        }
      });
      return Categories;
    },
    // getCategories(state) {
    //   // asaf version
    //   let Categories = {};

    //   state.parts.forEach((part) => {

    //     const categoryId = part?.category?.categoryId;
    //     const categoryName = part?.category?.categoryName;
    //     const rootCategoryId = part?.category?.categoryName;
    //     const categoryImage = part?.category?.categoryName;

    //     if (categoryId) {
    //       if (typeof Categories[categoryId] === "undefined") {
    //         Categories[categoryId].categoryId = categoryId;
    //         Categories[categoryId].categoryName = categoryName;
    //         Categories[categoryId].rootCategoryId = rootCategoryId;
    //         Categories[categoryId].categoryImage = categoryImage;
    //         Categories[categoryId].counter = 0;
    //         Categories[categoryId].custCounter = 0;
    //       }
    //       Categories[categoryId].counter++;
    //       if (part?.CustParts?.length > 0)
    //         Categories[categoryId].custCounter++;
    //     }
    //   });
    //   return Categories;
    // },
    getCarouselProducts: (state) => state.carouselProducts,
    getIsLoading: (state) => state.isLoading,
  },
};
